






















import lottie from 'lottie-web';
import { defineComponent, ref, onMounted, onUnmounted } from '@vue/composition-api';
import { httpUrl } from '@/renderer/scripts/http';
export default defineComponent({
  setup(props, context) {
    // 动画
    const fadeIn = ref(1);
    let timer: any = null;
    const showAnimation = ref(false);
    const methods = {
      // 文字动画控制
      initTextAnimation() {
        const setTimer = () => {
          timer = setTimeout(() => {
            if (fadeIn.value === 3) fadeIn.value = 0;
            fadeIn.value += 1;
            clearTimeout(timer);
            setTimer();
          }, 5000);
        };
        setTimer();
      },
      // 背景图动画
      initImgAnimation() {
        const img: Element = document.querySelector('.smh-login__login-img') as Element;
        const animation = lottie.loadAnimation({
          container: img,
          // 包含动画的dom元素
          renderer: 'svg',
          // 渲染出来的是什么格式
          loop: true,
          // 循环播放
          autoplay: true,
          // 自动播放
          path: `${httpUrl.staticCDNUrl}/tools/images/loginAnimation/data.json`, // 动画json的路径
        });
        // 动图加载完成
        animation.addEventListener('data_ready', () => {
          showAnimation.value = true;
          animation.removeEventListener('data_ready');
        });
        animation.addEventListener('data_failed', () => {
          showAnimation.value = false;
          animation.removeEventListener('data_failed');
        });
      },
    };
    onMounted(async () => {
      methods.initTextAnimation();
      methods.initImgAnimation();
    });
    onUnmounted(() => {
      clearTimeout(timer);
      timer = null;
    });
    return {
      showAnimation,
      fadeIn,
      ...methods,
    };
  },
});
